<template>
    <div class="main-con el-main">
        <router-view />
    </div>
</template>

<script>
    export default {
        name: "ContractSealProcessView"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/ContractSealProcessView.vue